export interface DraftQuestion {
  id: string;
  optionIds: string[];
}

type Answers = Record<string, string[]>;
const key = (assignmentId: string) => `pretest-draft:${assignmentId}`;

export const readPretestDraft = (
  assignmentId: string,
  pretestId: string,
  questions: DraftQuestion[]
): Answers => {
  try {
    const draft = JSON.parse(
      sessionStorage.getItem(key(assignmentId)) ?? 'null'
    );
    if (draft?.pretestId !== pretestId || !draft.answers) return {};

    return Object.fromEntries(
      questions.flatMap(({ id, optionIds }) => {
        const chosen = draft.answers[id];
        if (!Array.isArray(chosen)) return [];
        const valid = chosen.filter(
          (option: unknown): option is string =>
            typeof option === 'string' && optionIds.includes(option)
        );
        return [[id, [...new Set(valid)]]];
      })
    );
  } catch {
    return {};
  }
};

export const writePretestDraft = (
  assignmentId: string,
  pretestId: string,
  answers: Answers
) => {
  try {
    sessionStorage.setItem(
      key(assignmentId),
      JSON.stringify({ pretestId, answers })
    );
  } catch {
    // Storage can be disabled or full; answering must still work in memory.
  }
};

export const clearPretestDraft = (assignmentId: string) => {
  try {
    sessionStorage.removeItem(key(assignmentId));
  } catch {
    // A stale draft cannot cross into a different recorded pretest.
  }
};
